import RelationalDocLabel from './RelationalDocLabel'

export default RelationalDocLabel
